import React, { Component } from 'react';

import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../generics/help';
import { labSectionsByHf } from '../../libs/services';
import LabelForm from '../../components/LabelForm';
import SelectForm from '../../components/SelectForm';


const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;


var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../config');

class SamplesSend extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
        this.setTable = this.setTable.bind(this);

		this.state = {
            type:'',
			start_date: "",
			end_date:"",
            status:'',
            lab_sections_id:'all',
            sections:[],
			filename:"Envío de Muestras a Banco de Sangre Concentradores",
            health_facilities_id:'',
			columns:[
				{title:'No.'},
				{title:'Folio de la Muestra'},
				{title:'IDEE Paciente/Donador'},
				{title:'Tipo Estudio'},
				{title:'Clave del Estudio'},
				{title:'Clave de la Prueba'},
                {title:'Descripción de Prueba'}
			],
			listado:[],
            unidadEnvia:'',
            claveOrigen:'',
            unidadRecibe:'',
            clavePresupuestal:'',
            tipoSolicitud:'',
            statusSolicitud:'',
            fechaInicio:'',
            fechaFin:'',
            claveEstudio:''
		}

	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
		});

		if(!this.props.hiddeToImss){
			this.props.reload('hiddeToImss');
		}
	}

	async componentDidMount(){	
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
			});
		});

        var id = sessionStorage.getItem('health_facilities_id');
		var response = await labSectionsByHf(id);
        if(response){
            let options = response.map((res)=>{
                var obj = {
                    value:res.id,
                    text:res.name
                };

                return obj;
            });

            options.unshift({value:'all', text:'TODOS'});
            this.setState({sections: options});
        }

        this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

	searching(){
		if(this.isValidForm()){
			this.props.waiting.handleShow('Buscando...');

			var object = {
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),				
				option:this.state.type,
                start_date: this.state.start_date,
				end_date: this.state.end_date,
				status:this.state.status,
                lab_section_id: this.state.lab_sections_id
			};


			fetch(Config.default.apiGateway.URL+'reports_imss/sending_samples', {
				method : 'post',
				body:JSON.stringify(object),
				headers : new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			})
			.then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			})
			.then(response => {				
				if(response !== undefined && response !== null && response.error == null){
                    let list = [];
                    response.records.forEach((rec, i)=>{
                        list.push([
                            i+1,
                            rec.sample_number,
                            rec.person_idee,
                            rec.section_name,
                            rec.section_key,
                            rec.test_key,
                            rec.description,
                        ]);
                    });

					this.setState({
                        unidadEnvia: response.shipping_center,
                        claveOrigen: response.shipping_center_key,
                        unidadRecibe: response.receiving_center,
                        clavePresupuestal: response.receiving_center_key,
                        tipoSolicitud: response.priority,
                        statusSolicitud: response.status,
                        fechaInicio: moment(response.start_date).format('DD/MM/YYYY'),
                        fechaFin: moment(response.end_date).format('DD/MM/YYYY'),
                        claveEstudio: response.lab_section,
                        listado:list
                    });

                    setTimeout(()=>{
                        this.props.waiting.handleShow('Cargando...');
                        this.$el = $(this.el);
                        this.$el.DataTable().destroy();
                        this.$el.empty();
                    }, 500);

                    setTimeout(()=>{
                        this.props.waiting.handleClose();
                        this.setTable();
                    }, 1000);
                
                        
                    this.props.waiting.handleClose();
				}
			})
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

    setTable(){
		this.$el = $(this.el);

        var obj = {
            health_facilities_id: sessionStorage.getItem('health_facilities_id'),				
            option:this.state.type,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            status:this.state.status,
            lab_section_id: this.state.lab_sections_id
        }

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [                
				{
                	extend: 'excelHtml5',
                	title: this.state.filename,
                	action: (e, dt, node, config)=>{
                        this.props.printExcelReport(this.state.filename, 'sending_samples', obj);
                    }
            	},
                {
                    text:'PDF',
                    action: (e, dt, node, config)=>{
                        this.props.printPdfIMSSReports('sending_samples', obj);
                    }
                }
            ],
			data: this.state.listado,
			columns:this.state.columns,			
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
			},
			paging:false,
			ordering:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.dt-button').disable();
		}else {
			table.buttons('.dt-button').enable();
		}
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					IMSS ->
					{this.state.filename}
					</h5>
				</div>

				<Help 
					{...this.props}
		            menu={"help_imss"} 
		            submenu={"help_sending_samples"}  />
		            
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12"><span>Campos Requeridos (*)</span></div>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Tipo de Solicitud</span>
									<select className="form-control" name="type" id="type"
										value={this.state.type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="ORDINARIA">Ordinario</option>
										<option value="URGENTE">Urgente</option>
									</select>
								</div>
                                <div className="form-group">
                                    <span className="span-min">Fecha Desde</span>
                                    <input type="date" className="form-control hour-input" name="start_date" id="start_date"
                                        value={this.state.start_date} onChange={this.handleChange} required />
                                </div>
                                <div className="form-group">
                                    <span className="span-min">Fecha Hasta</span>
                                    <input type="date" className="form-control hour-input" name="end_date" id="end_date"
                                        value={this.state.end_date} onChange={this.handleChange} required />
                                </div>
                                <div className="form-group">
									<span className="span-min">Estatus</span>
									<select className="form-control" name="status" id="status"
										value={this.state.status} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="PENDING">Pendiente</option>
										<option value="ACCEPTED">Procesado</option>
									</select>
								</div>
								<div className="form-group">
                                    <LabelForm text="Sección" />
                                    <SelectForm 
                                        id="lab_sections_id"
                                        value={this.state.lab_sections_id}
                                        options={this.state.sections}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 form-group" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",fontSize: "20px"}}>
										<span>
											{this.state.filename}
										</span>
									</div>
                                    <div className='col-xs-12 form-group'>
                                        <div className='col-xs-12 col-md-3'>
                                            <label><b>Unidad Médica que Envía</b></label>
                                            <span style={{display:'block'}}>{this.state.unidadEnvia}</span>
                                        </div>
                                        <div className='col-xs-12 col-md-3'>
                                            <label><b>Clave Presupuestal</b></label>
                                            <span style={{display:'block'}}>{this.state.claveOrigen}</span>
                                        </div>
                                        <div className='col-xs-12 col-md-3'>
                                            <label><b>Unidad Médica que Recibe</b></label>
                                            <span style={{display:'block'}}>{this.state.unidadRecibe}</span>
                                        </div>
                                        <div className='col-xs-12 col-md-3'>
                                            <label><b>Unidad Médica que Envía</b></label>
                                            <span style={{display:'block'}}>{this.state.clavePresupuestal}</span>
                                        </div>
                                    </div>
                                    <div className='col-xs-12 form-group'>
                                        <div className='col-xs-12 col-md-6'>
                                            <label><b>Tipo de Solicitud </b></label>
                                            <span style={{marginLeft:5}}>{this.state.tipoSolicitud}</span>
                                        </div>
                                        <div className='col-xs-12 col-md-6'>
                                            <label><b>Estatus </b></label>
                                            <span style={{marginLeft:5}}>{this.state.statusSolicitud}</span>
                                        </div>
                                        <div className='col-xs-12 col-md-6'>
                                            <label><b>Fecha </b></label>
                                            <span style={{marginLeft:5}}>{this.state.fechaInicio+' a '+this.state.fechaFin}</span>
                                        </div>
                                        <div className='col-xs-12 col-md-6'>
                                            <label><b>Estudio</b></label>
                                            <span style={{marginLeft:5}}>{this.state.claveEstudio}</span>
                                        </div>
                                    </div>
								</div>
								<div className="col-xs-12" id="table-to-pdf">																		
									<div className="table-responsive">
                                        <table style={{fontSize:"11px"}} className="expenses-discards" id="table-to-xls" 
											width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (SamplesSend);